/**
 * Ink Pairing Selector
 * Lets customers pick two Lorcana ink colors and navigate to a filtered collection.
 * Supports Standard / Infinity format toggle.
 */
(function () {
  'use strict';

  var INK_COLORS = {
    Amber:    '#D4A017',
    Amethyst: '#7B4FA0',
    Emerald:  '#1E8C4E',
    Ruby:     '#C0392B',
    Sapphire: '#2471A3',
    Steel:    '#707B84'
  };

  document.querySelectorAll('.ink-selector').forEach(initSelector);

  function initSelector(section) {
    var items = section.querySelectorAll('.ink-selector__item');
    var cta = section.querySelector('.ink-selector__cta');
    var hint = section.querySelector('.ink-selector__hint');
    var dualNote = section.querySelector('.ink-selector__dual-note');
    var formatBtns = section.querySelectorAll('.ink-selector__format-btn');

    /* Default collection from the section's data attribute */
    var collectionHandle = section.dataset.collection || 'standard-legal';

    var selected = [];

    /* --- Format toggle (Standard / Infinity) --- */
    formatBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        formatBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        collectionHandle = btn.dataset.collection || collectionHandle;
        /* Refresh the CTA link if inks are already selected */
        updateCTA();
      });
    });

    /* --- Ink selection --- */
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var ink = item.dataset.ink;
        var idx = selected.indexOf(ink);

        if (idx !== -1) {
          /* Deselect */
          selected.splice(idx, 1);
          item.classList.remove('is-selected');
        } else if (selected.length < 2) {
          /* Select */
          selected.push(ink);
          item.classList.add('is-selected');
        } else {
          /* Already 2 selected — replace the first one */
          var oldest = selected.shift();
          section.querySelector('[data-ink="' + oldest + '"]').classList.remove('is-selected');
          selected.push(ink);
          item.classList.add('is-selected');
        }

        updateCTA();
      });
    });

    function updateCTA() {
      if (selected.length === 2) {
        /* Build the pairing tag: alphabetical order, e.g. "Ink: Amber-Steel" */
        var sorted = [selected[0], selected[1]].sort();
        var pairingTag = 'Ink: ' + sorted[0] + '-' + sorted[1];

        /* Build the filter URL using a single pairing tag */
        var url = '/collections/' + collectionHandle +
          '?filter.p.tag=' + encodeURIComponent(pairingTag);

        cta.href = url;
        cta.textContent = '';

        /* Build button content: dot + name / dot + name + arrow */
        var frag = document.createDocumentFragment();

        var dot1 = document.createElement('span');
        dot1.className = 'ink-selector__dot ink-selector__dot--' + selected[0].toLowerCase();
        frag.appendChild(dot1);

        var label = document.createTextNode(
          selected[0] + ' / ' + selected[1]
        );
        frag.appendChild(label);

        var dot2 = document.createElement('span');
        dot2.className = 'ink-selector__dot ink-selector__dot--' + selected[1].toLowerCase();
        frag.appendChild(dot2);

        /* Arrow icon */
        var arrow = document.createElement('span');
        arrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
        arrow.style.display = 'inline-flex';
        arrow.style.width = '18px';
        arrow.style.height = '18px';
        arrow.style.marginLeft = '0.3rem';
        frag.appendChild(arrow);

        cta.appendChild(frag);

        /* Gradient background using both ink colors */
        var c1 = INK_COLORS[selected[0]] || '#333';
        var c2 = INK_COLORS[selected[1]] || '#333';
        cta.style.background = 'linear-gradient(135deg, ' + c1 + ', ' + c2 + ')';

        cta.classList.add('is-visible');

        if (hint) hint.classList.add('is-hidden');
        if (dualNote) dualNote.classList.add('is-visible');
      } else {
        cta.classList.remove('is-visible');
        cta.style.background = '';

        if (hint) hint.classList.remove('is-hidden');
        if (dualNote) dualNote.classList.remove('is-visible');
      }
    }
  }
})();
